import React, { useState, useEffect, useRef } from "react";
import { useWindowWidth } from '../hooks/useDebounce';
import { PDFDocument as PDFLibDocument, rgb, StandardFonts } from 'pdf-lib';
import { Document, Page, pdfjs } from 'react-pdf';
import '@react-pdf/renderer';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import "react-pdf/dist/esm/Page/TextLayer.css";
import { PDFViewer, PDFDownloadLink, Page as PdfPage, Text, View, Document as PdfDocument, StyleSheet } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import fontkit from '@pdf-lib/fontkit';
import '../index.css';
import { FaEdit } from 'react-icons/fa';
import Slider from '@mui/material/Slider';
import { Paper, Skeleton, Box, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import axios from "axios";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import { useDirectionContext } from '../contexts/DirectionContext';
import { Toaster } from 'react-hot-toast';

// local imports
import { LoadingOverlay } from './loading';
import RequestedFilesList from "./RequestedFilesList.jsx";
import TextInput from "./inputs/TextInput.jsx";
import SelectInput from "./inputs/SelectInput.jsx";
import SignatureInput from "./inputs/SignatureInput.jsx";
import DateInput from "./inputs/DateInput.jsx";
import IsraeliIdInput from "./inputs/IsraeliIdInput.jsx";
import FormStepper from "./minorComponents/FormStepper.jsx";
import EnhancedProgress from "./minorComponents/EnhancedProgress.jsx";
import TrustBanner from "./minorComponents/TrustBanner.jsx";
import CompletionScreen from "./minorComponents/CompletionScreen.jsx";
import ModernHeader from "./minorComponents/ModernHeader.jsx";
import constants from './constants.json';
import notifications from '../utils/notifications';
import { colors, spacing, typography, shadows, radius, transitions } from '../theme/tokens';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// CONSTANTS - Replicated from working version
const EMPTY_SIGNATURE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAADICAYAAAC3QRk5AAAAAXNSR0IArs4c6QAABmJJREFUeF7t1DENADAMBLEEQPnTrVQKvdEB8IMV3c7MGUeAAAEC3wIrqN+GBggQIPAEBNUjECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUPECBAIBIQ1AjSDAECBATVDxAgQCASENQI0gwBAgQE1Q8QIEAgEhDUCNIMAQIEBNUjIAAAAAAElFTkSuQmCC";

const DEFAULT_FORM_DATA = {
  day: "",
  month: "",
  year: "",
  childName: "",
  childId: "",
  parentName1: "",
  parentId1: "",
  phoneNumber1: "",
  parentName2: "",
  parentId2: "",
  phoneNumber2: "",
  kindergarten: "",
  hebrewYear: "",
  childFirstName: "",
  childLastName: "",
  dateOfBirth: "",
  countryOfBirth: "",
  yearOfArrival: "",
  address: "",
  zip: "",
  brother1: "",
  brother2: "",
  brother3: "",
  brother4: "",
  parentJob1: "",
  parentHomeNumber1: "",
  parentEmailAddress1: "",
  parentJob2: "",
  parentHomeNumber2: "",
  parentEmailAddress2: "",
  relativeName1: "",
  relativeStatus1: "",
  relativeNumber1: "",
  relativeName2: "",
  relativeStatus2: "",
  relativeNumber2: "",
  healthIssueExist: "false",
  healthIssueAndSolution: "",
  allergyToMedication: "",
  allergyToFood: "",
  pastDiseases: "",
  allergies: "",
  receivedFullVaccination: "true",
  nonReceivedVaccinations: "",
  hmo: "",
  remarks: "",
  attendanceStartingDate: "",
  from: "",
  signingDate: "",
  className: "",
  monthlyPayment: "",
  paymentMethod: "12-checks",
  allowsPhotographingInternal: "false",
  allowsPhotographingExternal: "false",
  approverName: "",
  approverStatus: "",
  approverAddress: "",
  approverPhoneNumber: "",
  doctorName: "",
  previousKindergarten: "",
  parentWorkPlace1: "",
  parentWorkPlace2: "",
  parentWorkPhoneNumber1: "",
  parentWorkPhoneNumber2: "",
  childOrderBetweenSiblings: "",
  emergencyContactName: "",
  emergencyContactNumber: "",
  signature1: EMPTY_SIGNATURE,
  signature2: EMPTY_SIGNATURE,
};

// Styled components for brand consistency
const StyledButton = styled(Button)(({ theme, variant }) => ({
  textTransform: 'none',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: '500',
  padding: '12px 24px',
  transition: 'all 0.3s ease',
  boxShadow: 'rgba(26, 0, 0, 0.1) 0 2px 8px',

  ...(variant === 'contained' && {
    backgroundColor: colors.primary.main,
    color: '#ffffff',
    border: 'none',
    '&:hover': {
      backgroundColor: colors.primary.dark,
      transform: 'translateY(-2px)',
      // Use filter instead of boxShadow for better performance (GPU-accelerated)
      filter: 'drop-shadow(0 4px 12px rgba(26, 0, 0, 0.15))',
    },
    '&:disabled': {
      backgroundColor: '#bdbdbd',
      color: '#ffffff',
      transform: 'none',
      boxShadow: 'none',
    }
  }),

  ...(variant === 'outlined' && {
    backgroundColor: '#ffffff',
    color: colors.text.secondary,
    border: `1px solid ${colors.border.light}`,
    boxShadow: 'none',
    '&:hover': {
      borderColor: colors.primary.main,
      color: colors.primary.main,
      backgroundColor: colors.neutral[50],
    },
    '&:disabled': {
      backgroundColor: '#f9fafb',
      color: '#bdbdbd',
      borderColor: '#bdbdbd',
    }
  })
}));

const StyledCard = styled('div')({
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  boxShadow: 'rgba(26, 0, 0, 0.1) 0 4px 16px',
  border: '1px solid #EAEEF2',
  transition: 'all 0.3s ease',
  '&:hover': {
    // Use filter instead of boxShadow for better performance (GPU-accelerated)
    filter: 'drop-shadow(0 6px 20px rgba(26, 0, 0, 0.15))',
  }
});

const StyledInput = styled('input')({
  border: '2px solid #EAEEF2',
  borderRadius: '8px',
  padding: '12px 16px',
  fontSize: '16px',
  fontWeight: '400',
  color: '#333333',
  backgroundColor: '#ffffff',
  transition: 'all 0.3s ease',
  '&:focus': {
    outline: 'none',
    borderColor: colors.primary.main,
    backgroundColor: '#f9fafb',
    boxShadow: 'rgba(19, 36, 161, 0.1) 0 0 0 3px',
  },
  '&::placeholder': {
    color: '#666666',
  }
});

const StyledFileInput = styled('input')({
  border: '2px dashed #EAEEF2',
  borderRadius: '12px',
  padding: '16px',
  fontSize: '16px',
  color: '#333333',
  backgroundColor: '#f9fafb',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: colors.secondary.main,
    backgroundColor: '#ffffff',
  },
  '&:focus': {
    outline: 'none',
    borderColor: colors.primary.main,
    boxShadow: 'rgba(19, 36, 161, 0.1) 0 0 0 3px',
  }
});

// LoadingOverlay now imported from './loading' system

// Additional styled components for remaining inline styles
const PageContainer = styled('div')({
  backgroundColor: colors.neutral[200],
  minHeight: '100vh',
  fontFamily: typography.fontFamily.primary
});

const Header = styled('div')({
  backgroundColor: colors.primary.main,
  color: colors.primary.contrast,
  padding: `${spacing.lg} 0`,
  marginBottom: spacing.lg,
  boxShadow: shadows.md,
});

const HeaderTitle = styled('h1')({
  textAlign: 'center',
  margin: 0,
  fontSize: typography.fontSize['3xl'],
  fontWeight: typography.fontWeight.semibold,
  letterSpacing: '-0.5px',
});

// LoadingText and UploadProgressText removed - handled by LoadingOverlay component

const ContentWrapper = styled('div')({
  padding: `0 ${spacing.md}`,
});

const PdfContainer = styled('div')({
  width: '100%',
  overflow: 'hidden',
  position: 'relative',
});

const NavigationCard = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: spacing.md,
  backgroundColor: colors.neutral[50],
  borderTop: `1px solid ${colors.border.light}`,
  gap: spacing.md,
});

const PageNumber = styled('div')({
  fontSize: typography.fontSize.lg,
  fontWeight: typography.fontWeight.semibold,
  color: colors.text.primary,
  padding: `0 ${spacing.md}`,
});

const FileUploadContainer = styled('div')({
  marginTop: spacing.lg,
  padding: spacing.lg,
  backgroundColor: colors.background.subtle,
  borderRadius: radius.card,
  border: `2px dashed ${colors.border.light}`,
});

const FileUploadLabel = styled('label')(({ direction }) => ({
  display: 'block',
  fontSize: typography.fontSize.lg,
  fontWeight: typography.fontWeight.semibold,
  color: colors.text.primary,
  marginBottom: spacing.sm,
  textAlign: direction === 'rtl' ? 'right' : 'left',
}));

const CompletionCard = styled(StyledCard)({
  marginBottom: spacing.lg,
  padding: '40px',
  textAlign: 'center',
});

const CompletionTitle = styled('h2')({
  fontSize: typography.fontSize['2xl'],
  fontWeight: typography.fontWeight.semibold,
  color: colors.text.primary,
  marginBottom: spacing.xl,
  margin: 0,
});

const CompletionForm = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: spacing.md,
  flexWrap: 'wrap',
});

const NavigationButtons = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: `0 0 40px 0`,
  gap: spacing.md,
});

// CRITICAL: PDF Container with minimal styling to avoid positioning issues - REMOVED since we're using direct div

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PdfSign(props) {
  const { t } = useTranslation();
  const direction = useDirectionContext();

  const [inputFields, setInputFields] = useState([]);
  const [signatures, setSignatures] = useState([]);
  const [containerBounds, setContainerBounds] = useState([]);
  const [clicks, setClicks] = useState([]);
  const [clickX, setClickX] = useState(null);
  const [clickY, setClickY] = useState(null);
  const [numPages, setNumPages] = useState(0);
  const containerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageWidth, setPageWidth] = useState(null);
  const [pageHeight, setPageHeight] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [signatureOpen, setSignatureOpen] = useState(false);
  const [documentLoaded, setDocumentLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [approverPhoneNumber, setApproverPhoneNumner] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [requireID, setRequireID] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [requestedFiles, setRequestedFiles] = useState([]);
  const [files, setFiles] = useState({});
  const [modifiedFileNames, setModifiedFileNames] = useState({});
  const [uploadProgress, setUploadProgress] = useState(0);
  const [visibleDiv, setVisibleDiv] = useState(0);
  // CRITICAL FIX: Track the actual rendered PDF width (container width, not window width)
  const [renderedPdfWidth, setRenderedPdfWidth] = useState(null);

  // Access the parameter using useParams
  const { key } = useParams();
  const navigate = useNavigate();

  const [addingTextInputField, SetAddingTextInputField] = useState(false);
  const [addingSignatureInputField, SetAddingSignatureInputField] = useState(false);

  const query = useQuery();

  const govId = query.get("gov_id");
  const username = query.get("username");
  const signatureHash = query.get("signature_hash");
  const requestId = query.get("request_id");

  // for parent signing
  const child_name = query.get("child_name");
  const signer_name = query.get("signer_name");
  const child_dob = query.get("child_dob");

  // for teacher signing
  const child_id = query.get("child_id");
  const first_name = query.get("first_name");
  const last_name = query.get("last_name");
  const kindergarten = query.get("kindergarten");
  const parent_name = query.get("parent_name");
  const parent_phone = query.get("parent_phone");
  const form_id = query.get("form_id");

  const fontFileUrl = '/DavidLibre-Regular.ttf';
  const arabicFontUrl = '/Tahoma Regular font.ttf';
  const isArabic = (text) => /[\u0600-\u06FF]/.test(text);

  // Use debounced window width hook (150ms debounce) - handles mobile viewport correctly
  const windowWidth = useWindowWidth(150);

  // Update container bounds when window resizes or visibleDiv changes
  useEffect(() => {
    setContainerBounds(containerRef.current?.getBoundingClientRect());
  }, [windowWidth, visibleDiv]);

  useEffect(() => {
    // Function to fetch data from the backend server
    const fetchData = async () => {
      try {
        // Make the GET request using Axios
        const response = await axios.get(`${window.AppConfig.serverDomain}/api/organzations/document-input-fields/${key}`);

        //----------------------------------------------------------
        if (response?.data?.templateName) {
          const fetchedPdfFile = `${window.AppConfig.serverDomain}/api/documentSign/${response?.data?.templateName?.split('.')[0]}${response?.data?.templateName.includes('_') ? "" : `_${response?.data?.templateID}`}.pdf`;
          setPdfFile(fetchedPdfFile);

          const pdf = await pdfjs.getDocument(fetchedPdfFile).promise;
          setNumPages(pdf.numPages);

          // REMOVED: Don't set pageWidth/pageHeight here - they're set correctly in handlePdfLoadSuccess
          // using page.originalWidth/originalHeight from react-pdf Page component
        }
        //----------------------------------------------------------

        await setParameterData(response.data.inputFields, child_name, signer_name, child_dob);
        // Update the state with the fetched data
        if (response.data.inputFields) {
          setRequireID(response.data.requireID);
        }
        if (response?.data?.requestedFiles) {
          setRequestedFiles(response?.data?.requestedFiles);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchData function when the component mounts
    fetchData();
  }, []);

  function updateValidity(index) {
    const updatedInputFields = [...inputFields];
    updatedInputFields[index].valid = false;
    setInputFields(updatedInputFields);
  }

  const handleNextClick = () => {
    if (visibleDiv === 0) {
      var foundNotFilled = false;

      inputFields.some((field, index) => {
        if (field?.mandatory === true && (field?.editor.inputType.value.includes('signature'))) {
          // Signature validation: check for empty signature or no value
          if (!field?.value || field?.value === constants.emptySignature || field?.value === EMPTY_SIGNATURE) {
            updateValidity(index);
            notifications.error(t('pdfSign.signatureRequiredError'));
            foundNotFilled = true;
            setCurrentPage(field?.page);
            return true;
          }
        } else if (field?.mandatory === true && (!field?.value || field?.value.toString().trim() === "")) {
          updateValidity(index);
          notifications.error(t('pdfSign.fieldEmptyError', { fieldLabel: field?.editor.inputType.label, page: field.page }));
          foundNotFilled = true;
          setCurrentPage(field?.page);
          return true;
        }
      })

      if (foundNotFilled) {
        return;
      }

      setVisibleDiv(current => current + ((requestedFiles.length > 0 || requireID) ? 1 : 2));

    } else if (visibleDiv === 1) {
      if (!mandatoryFilesSubmitted()) {
        return;
      }
      setVisibleDiv(current => current + 1);
    }
  };

  const handlePreviousClick = () => {
    setVisibleDiv(current => current - 1);
  };

  async function setParameterData(fetchedInputFields, child_name, signer_name, child_dob) {
    const updatedInputFields = [...fetchedInputFields];

    fetchedInputFields.forEach((field, index2) => {
      if (field.editor.inputType.value === "childName" && child_name !== null) {
        updatedInputFields[index2].value = child_name;
      } else if (field.editor.inputType.value === "approverName" && signer_name !== null) {
        updatedInputFields[index2].value = signer_name;
      } else if (field.editor.inputType.value === "dateOfBirth" && child_dob !== null && child_dob !== "") {
        updatedInputFields[index2].value = child_dob;
      } else if (field.editor.inputType.value === "childId" && govId !== null) {
        updatedInputFields[index2].value = govId;
      } else if (field.editor.inputType.value === "childId" && child_id !== null) {
        updatedInputFields[index2].value = child_id;
      } else if (field.editor.inputType.value === "childFirstName" && first_name !== null) {
        updatedInputFields[index2].value = first_name;
      } else if (field.editor.inputType.value === "childLastName" && last_name !== null) {
        updatedInputFields[index2].value = last_name;
      } else if (field.editor.inputType.value === "kindergarten" && kindergarten !== null) {
        updatedInputFields[index2].value = kindergarten;
      } else if (field.editor.inputType.value === "parentName1" && parent_name !== null) {
        updatedInputFields[index2].value = parent_name;
      } else if (field.editor.inputType.value === "phoneNumber1" && parent_phone !== null) {
        updatedInputFields[index2].value = parent_phone;
      }
    })

    const updatedFields = updatedInputFields.map(field => ({ ...field, valid: true }));
    setInputFields(updatedFields);
  }

  const handleInputChange = (event, index) => {
    const updatedInputFields = [...inputFields];

    inputFields.forEach((field, index2) => {
      if (field.editor.inputType.value === inputFields[index].editor.inputType.value) {
        const sanitizedInput = DOMPurify.sanitize(event.target.value);
        updatedInputFields[index2].value = sanitizedInput;
        updatedInputFields[index2].valid = true;
      }
    })
    setInputFields(updatedInputFields);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const isAllowedFileType = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png'];
    return allowedTypes.includes(file.type);
  };

  /**
   * Enhanced image compression with WEBP support and progressive quality reduction
   * @param {string} image - Base64 data URL of the image
   * @param {number} maxWidth - Maximum width in pixels
   * @param {number} maxHeight - Maximum height in pixels
   * @param {File} originalFile - Original file for size comparison
   * @returns {Promise<string>} - Blob URL of the compressed image
   */
  const compressImage = async (image, maxWidth, maxHeight, originalFile) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = image;

      img.onerror = () => reject(new Error('Failed to load image'));

      img.onload = async () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Calculate scaled dimensions while maintaining aspect ratio
        if (width > maxWidth || height > maxHeight) {
          const aspectRatio = width / height;
          if (width > maxWidth) {
            width = maxWidth;
            height = width / aspectRatio;
          }
          if (height > maxHeight) {
            height = maxHeight;
            width = height * aspectRatio;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Compress to JPEG (pdf-lib only supports JPEG and PNG, so avoid WebP)
        const MAX_SIZE_MB = 1; // Target max size: 1MB
        const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
        let quality = 0.9;
        let jpegBlob = null;

        while (quality >= 0.5) {
          jpegBlob = await new Promise((res) => {
            canvas.toBlob((blob) => res(blob), 'image/jpeg', quality);
          });

          // Stop if we're under the target size or original size
          if (jpegBlob.size <= MAX_SIZE_BYTES || jpegBlob.size < originalFile.size * 0.8) {
            break;
          }

          // Reduce quality for next iteration
          quality -= 0.1;
        }

        // Use compressed image only if it's actually smaller than original
        if (jpegBlob && jpegBlob.size < originalFile.size) {
          console.log(`Compressed with JPEG (q=${quality.toFixed(1)}): ${originalFile.size} bytes → ${jpegBlob.size} bytes (${Math.round(jpegBlob.size / originalFile.size * 100)}%)`);
          resolve(URL.createObjectURL(jpegBlob));
        } else {
          // Original is smaller - use it directly
          console.log(`Using original image (compressed version was larger): ${originalFile.size} bytes`);
          resolve(image); // Return original base64 data URL
        }
      };
    });
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      notifications.error(constants.validationMessages.imageOnlyError);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      notifications.error(constants.validationMessages.fileSizeError);
      return;
    }

    if (!isAllowedFileType(file)) {
      notifications.error(constants.validationMessages.invalidFileType);
      e.target.value = null;
      return;
    }

    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        // Pass original file for size comparison
        const compressedImage = await compressImage(reader.result, 1500, 1200, file);
        setSelectedImage(compressedImage);
      } catch (error) {
        console.error('Image compression failed:', error);
        notifications.error(constants.validationMessages.compressionError || 'Failed to compress image. Please try again.');
        e.target.value = null;
      }
    };

    reader.onerror = () => {
      notifications.error(constants.validationMessages.imageReadError || 'Failed to read image file.');
      e.target.value = null;
    };

    reader.readAsDataURL(file);
  };

  const wrapText = async (text, maxWidth, font, size) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach((word) => {
      const width = font.widthOfTextAtSize(line + word + ' ', size);
      if (width < maxWidth) {
        line += word + ' ';
      } else {
        lines.push(line);
        line = word + ' ';
      }
    });

    lines.push(line);
    return lines;
  };

  function mandatoryFilesSubmitted() {
    let response = true;

    requestedFiles.map((request, index) => {
      if (request.mandatory && !Object.keys(files).includes(String(index))) {
        notifications.error(constants.validationMessages.mandatoryFilesRequired.replace('{description}', request.description));
        response = false;
        return response;
      }
    });

    return response;
  }

  const handleOpenPDF = async () => {
    console.log('[handleOpenPDF] Starting submission process...');
    console.log('[handleOpenPDF] Phone number:', approverPhoneNumber, 'Length:', approverPhoneNumber.length);
    console.log('[handleOpenPDF] Input fields count:', inputFields.length);

    var foundNotFilled = false;

    inputFields.some(field => {
      if (field?.mandatory === true && (field?.editor.inputType.value.includes('signature'))) {
        if (!field?.value || field?.value === constants.emptySignature || field?.value === EMPTY_SIGNATURE) {
          console.log('[handleOpenPDF] Empty mandatory signature found');
          notifications.error(t('pdfSign.signatureRequiredError'));
          foundNotFilled = true;
          return true;
        }
      } else if (field?.mandatory === true && (!field?.value || field?.value.toString().trim() === "")) {
        console.log('[handleOpenPDF] Empty mandatory field found:', field.editor.inputType.label);
        notifications.error(t('pdfSign.fieldEmptyError', { fieldLabel: field?.editor.inputType.label, page: field.page }));
        foundNotFilled = true;
        return true;
      }
    })

    if (foundNotFilled) {
      console.log('[handleOpenPDF] Aborting: mandatory fields not filled');
      return;
    }

    if (approverPhoneNumber.length < 9) {
      console.log('[handleOpenPDF] Aborting: phone number too short');
      notifications.error(constants.validationMessages.phoneRequired);
      return;
    }

    console.log('[handleOpenPDF] Checking mandatory files...');
    if (!mandatoryFilesSubmitted()) {
      console.log('[handleOpenPDF] Aborting: mandatory files not submitted');
      return;
    }

    console.log('[handleOpenPDF] All validations passed, starting PDF generation...');

    let modified = {};

    Object.keys(files).forEach((key) => {
      const modifiedFileName = `file-${key}-${generateRandomString(16)}.${files[key].name.split('.').pop()}`;
      modified = {
        ...modified,
        [key]: modifiedFileName
      };
      setModifiedFileNames(currentFileNames => ({
        ...currentFileNames,
        [key]: modifiedFileName
      }));
    });

    try {
      // Show loading during PDF generation (before confirmation)
      setLoading(true);
      console.log('[handleOpenPDF] Loading overlay shown, fetching PDF...');

      var existingPdfBytes = await fetch(pdfFile).then(res => res.arrayBuffer());
      const pdfDoc = await PDFLibDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch(fontFileUrl).then(res => res.arrayBuffer());
      const customFont = await pdfDoc.embedFont(fontBytes);
      const arabicFontBytes = await fetch(arabicFontUrl).then(res => res.arrayBuffer());
      const arabicFont = await pdfDoc.embedFont(arabicFontBytes);

      const pages = pdfDoc.getPages();
      inputFields.forEach(async inputField => {
        if (inputField.editor.inputType.value !== 'signature1' && inputField.editor.inputType.value !== 'signature2') {
          const { value } = inputField;
          const { x, y } = inputField;
          pages.forEach(async (page, index) => {
            if (inputField.page === index + 1) {
              const pageHeight = page.getHeight();
              const sizeFont = 10;
              // y = normalized field TOP; text baseline drawn at field BOTTOM = y*pageHeight + fieldHeight_pdf
              // fieldHeight_pdf = (editor.height / 40) * pageWidth  (screen fieldHeight converted to PDF points)
              const adjustedY = pageHeight - y * (pageHeight) - (inputField.editor.height / 40) * pageWidth;
              console.log(`[PDF DRAW] field="${inputField.editor?.inputType?.value}" stored_y=${y} pageHeight=${pageHeight} pageWidth=${pageWidth} adjustedY=${adjustedY}`);
              const textFont = isArabic(value) ? arabicFont : customFont;
              const lines = await wrapText(value, pageWidth * inputField.editor.width / 1.5, textFont, sizeFont);

              lines.forEach((line, index) => {
                page.drawText(line, {
                  x: x * (pageWidth) + pageWidth * inputField.editor.width / 1.5 - textFont.widthOfTextAtSize(lines[index], sizeFont),
                  y: adjustedY - 14 * index,
                  font: textFont,
                  size: sizeFont,
                  color: rgb(0, 0, 0)
                });
              });
            }
          });
        } else if (inputField.editor.inputType.value === 'signature1' || inputField.editor.inputType.value == 'signature2') {
          const image = await pdfDoc.embedPng(inputField.value);
          const pngDims = image.scale(0.27)
          const { x, y } = inputField;
          pages.forEach((page, index) => {
            if (inputField.page === index + 1) {
              const pageHeight = page.getHeight();
              const adjustedY = pageHeight - y * (pageHeight) - pngDims.height;

              page.drawImage(image, {
                x: x * (pageWidth), y: adjustedY,
                width: pngDims.width,
                height: pngDims.height
              })
            }
          });
        }
      });

      if (requireID) {
        const imageBytes = await fetch(selectedImage).then((res) => res.arrayBuffer());
        const uint8 = new Uint8Array(imageBytes);
        const page = pdfDoc.addPage();

        // Detect format by magic bytes: JPEG starts with FF D8, PNG starts with 89 50
        const embeddedImage = (uint8[0] === 0x89 && uint8[1] === 0x50)
          ? await pdfDoc.embedPng(imageBytes)
          : await pdfDoc.embedJpg(imageBytes);

        const { width, height } = embeddedImage.scale(0.9);
        const width2 = width > page.getWidth() ? page.getWidth() : width;
        const height2 = width > page.getWidth() ? height * (page.getWidth() / width) : height;
        page.drawImage(embeddedImage, {
          x: page.getWidth() / 2 - width2 / 2,
          y: page.getHeight() / 2 - height2 / 2,
          width: width2,
          height: height2,
        });
      }

      if (Object.keys(files).length > 0) {
        const page = pdfDoc.addPage();
        const { width, height } = page.getSize();

        let y = height - 200;
        const x = 50;
        let counter = 0;
        const sizeFont = 12;

        for (let link of Object.entries(modified)) {
          const lines = await wrapText(`${requestedFiles[link[0]].description}`, pageWidth * 0.8, customFont, sizeFont);

          lines.forEach((line, index) => {
            page.drawText(`${index === 0 ? `${counter + 1}. ` : " "}${line}`, {
              x: x + pageWidth * 0.8 - customFont.widthOfTextAtSize(lines[index], sizeFont),
              y: y - 20 * (index),
              font: customFont,
              size: sizeFont,
              color: rgb(0, 0, 0)
            });
          });

          page.drawText(`${window.AppConfig.serverDomain}/api/documentSign/${link[1]}`, { x, y: y - (lines.length) * 20, size: sizeFont, color: rgb(0, 0, 1), font: customFont });
          y -= (lines.length + 2) * 20;
          counter = counter + 1;
        }
      }

      const modifiedPdfBytes = await pdfDoc.save();
      const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });

      console.log('[handleOpenPDF] PDF generated successfully, hiding loading and showing confirmation...');
      // CRITICAL: Hide loading before showing confirmation dialog
      // This allows user to see and interact with the confirmation dialog
      setLoading(false);

      // Small delay to ensure loading overlay is fully removed from DOM before showing confirmation
      await new Promise(resolve => setTimeout(resolve, 100));

      console.log('[handleOpenPDF] About to show confirmation dialog...');
      console.log('[handleOpenPDF] Confirmation message:', constants.validationMessages.confirmSubmission);

      const userConfirmed = await notifications.confirm(constants.validationMessages.confirmSubmission);

      console.log('[handleOpenPDF] User confirmation result:', userConfirmed);
      console.log('[handleOpenPDF] Confirmation dialog completed');

      if (userConfirmed) {
        // Now show loading overlay since user confirmed submission
        setLoading(true);
        console.log('[handleOpenPDF] User confirmed, starting upload...');

        const documentUrl = await submitSignedData(modifiedPdfBlob, modified);

        if (documentUrl?.status === "success") {
          navigate(`/success/${documentUrl.response}`);
        } else {
          notifications.error(constants.validationMessages.submissionError);
        }

        setLoading(false);
      } else {
        // User cancelled - no loading needed
        return;
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      notifications.error(`שגיאה ביצירת המסמך: ${error.message || 'שגיאה לא ידועה'}`);
      setLoading(false);
    }
  };

  function extractValues(input) {
    var extracted = constants.defaultFormData;

    input.forEach(field => {
      extracted = {
        ...extracted,
        [field.editor.inputType.value]: field.value,
      }
    });
    return extracted;
  }

  function generateRandomString(length) {
    const charset = "abcdefghijklmnopqrstuvwxz0123456789";
    let randomString = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      randomString += charset[randomIndex];
    }

    return randomString;
  }

  const submitSignedData = async (modifiedPdfBlob, modified) => {
    const localUrl = `${window.AppConfig.serverDomain}/api/organzations/submit/`;

    console.log('[submitSignedData] Backend URL:', localUrl);
    console.log('[submitSignedData] Server domain:', window.AppConfig.serverDomain);
    console.log('[submitSignedData] Template ID:', key.split('_').pop());
    console.log('[submitSignedData] Phone number:', approverPhoneNumber);

    const data = new FormData();
    data.append('data', JSON.stringify(extractValues(inputFields)));
    data.append('templateID', key.split('_').pop());
    data.append('pdf', modifiedPdfBlob, `${key}_${approverPhoneNumber}.pdf`);
    data.append('approverPhone', approverPhoneNumber);
    data.append('govId', govId ? govId : "null");
    data.append('username', username ? username : "null");
    data.append('signatureHash', signatureHash ? signatureHash : "null");
    data.append('requestId', requestId ? requestId : "null");
    Object.keys(files).forEach((key) => {
      data.append('files', files[key], modified[key]);
    });

    data.append('child_id', child_id ? child_id : "null");
    data.append('form_id', form_id ? form_id : "null");

    try {
      console.log('[submitSignedData] Starting axios POST request...');
      const response = await axios.post(localUrl, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log('[submitSignedData] Upload progress:', percentCompleted + '%');
          setUploadProgress(percentCompleted);
        },
      });

      console.log('[submitSignedData] Upload successful! Response:', response.data);
      return { status: "success", response: response?.data?.documentURL };
    } catch (error) {
      console.error('[submitSignedData] Upload failed! Error:', error);
      console.error('[submitSignedData] Error message:', error.message);
      console.error('[submitSignedData] Error response:', error.response);
      return { status: "error", response: error };
    }
  };

  const handleMouseEnter = (event, index) => {
    if (!signatureOpen) {
      setHoveredIndex(index);
    }
  };

  const handleMouseLeave = () => {
    if (!signatureOpen) {
      setHoveredIndex(null);
    }
  };

  function updateSignature(index, url) {
    setInputFields(prevInputFields => {
      const updatedInputFields = [...prevInputFields];
      inputFields.forEach((field, index2) => {
        if (field.editor.inputType.value === inputFields[index].editor.inputType.value) {
          updatedInputFields[index2].value = url;
          updatedInputFields[index2].valid = true;
        }
      })
      return updatedInputFields;
    });
  }

  async function handlePdfLoadSuccess(page) {
    setDocumentLoaded(true);

    // CRITICAL: Use page.originalWidth/originalHeight to match CreateNewTemplate.jsx positioning
    // This ensures input fields are positioned correctly
    if (page && page.originalWidth && page.originalHeight) {
      const pdfPageWidth = page.originalWidth;
      const pdfPageHeight = page.originalHeight;

      setPageWidth(pdfPageWidth);
      setPageHeight(pdfPageHeight);

      // CRITICAL FIX: Get the actual rendered PDF width from container
      // This is the width that the PDF is actually rendered at (accounting for padding)
      const actualRenderedWidth = containerRef.current?.clientWidth || windowWidth;
      setRenderedPdfWidth(actualRenderedWidth);

      console.log('[PdfSign] Page dimensions set:', {
        pageWidth: pdfPageWidth,
        pageHeight: pdfPageHeight,
        renderedPdfWidth: actualRenderedWidth,
        windowWidth: windowWidth,
        containerClientWidth: containerRef.current?.clientWidth
      });
    }
  }

  const handleSelectChange = (event, index) => {
    setInputFields(prevInputFields => {
      const updatedInputFields = [...prevInputFields];
      updatedInputFields[index].value = event.target.value;
      updatedInputFields[index].valid = true;
      return updatedInputFields;
    });
  }

  // Use the documentBytes as needed, e.g., display the PDF
  return (
    <PageContainer>
      {/* Toast notifications - CRITICAL: Must be present for confirmation dialogs to work */}
      <Toaster
        toastOptions={{ duration: 4000 }}
        containerStyle={{ zIndex: 99999 }}
      />

      {/* Modern Header with Organization Branding */}
      <ModernHeader
        organizationName={null} // TODO: Fetch from template data
        documentType={null} // TODO: Fetch from template data
      />

      {/* Loading Overlay */}
      <LoadingOverlay
        show={loading}
        message={t('pdfSign.processingDocument')}
        progress={uploadProgress}
      />

      <ContentWrapper>
        {/* Trust Banner */}
        <TrustBanner />

        {/* Enhanced Progress with Field Completion Count */}
        <EnhancedProgress
          visibleDiv={visibleDiv}
          inputFields={inputFields}
          requestedFiles={requestedFiles}
          requireID={requireID}
        />

        {/* PDF Document View */}
        <div className={`${visibleDiv === 0 ? '' : 'hidden'}`}>
          {/* CRITICAL: Remove StyledCard wrapper from PDF container to avoid measurement interference */}
          <PdfContainer ref={containerRef}>
            {!documentLoaded && pdfFile && (
              /* Skeleton for PDF loading */
              <StyledCard sx={{ padding: 0, overflow: 'hidden' }}>
                <Skeleton variant="rectangular" width="100%" height={600} />
                <Box sx={{ padding: spacing.md, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: spacing.sm }}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton variant="text" width={60} height={24} />
                  <Skeleton variant="circular" width={40} height={40} />
                </Box>
              </StyledCard>
            )}
            <Document file={pdfFile}>
              <div style={{ pointerEvents: `${addingTextInputField || addingSignatureInputField ? 'auto' : 'none'}`, display: documentLoaded ? 'block' : 'none' }}>
                <Page onLoadSuccess={handlePdfLoadSuccess} key={currentPage - 1} pageNumber={currentPage} width={containerRef.current?.clientWidth} />
              </div>
            </Document>
            {/* CRITICAL FIX: Pass renderedPdfWidth instead of windowWidth to fix mobile positioning */}
            {documentLoaded &&
              <>{inputFields.map((inputField, index) => (
                (inputField.page === currentPage) ?
                  <div key={index}>
                    {(inputField.editor.inputType.value === 'signature' ||
                      inputField.editor.inputType.value === 'signature1' ||
                      inputField.editor.inputType.value === 'signature2' ||
                      inputField.editor.inputType.value.includes('signature')) &&
                      <SignatureInput index={index} inputField={inputField} setHoveredIndex={setHoveredIndex} setSignatureOpen={setSignatureOpen} updateSignature={updateSignature} handleMouseEnter={handleMouseEnter} handleMouseLeave={handleMouseLeave} hoveredInde={hoveredIndex} windowWidth={renderedPdfWidth || windowWidth} pageHeight={pageHeight} pageWidth={pageWidth} />}

                    {(inputField.editor.inputType.value === 'dateOfBirth' ||
                      inputField.editor.inputType.value === 'signingDate') &&
                      <DateInput index={index} inputField={inputField} handleInputChange={handleInputChange} handleMouseEnter={handleMouseEnter} handleMouseLeave={handleMouseLeave} hoveredInde={hoveredIndex} windowWidth={renderedPdfWidth || windowWidth} pageHeight={pageHeight} pageWidth={pageWidth} />}

                    {inputField?.options?.length > 0 &&
                      <SelectInput index={index} inputField={inputField} handleSelectChange={handleSelectChange} handleMouseEnter={handleMouseEnter} handleMouseLeave={handleMouseLeave} hoveredInde={hoveredIndex} windowWidth={renderedPdfWidth || windowWidth} pageHeight={pageHeight} pageWidth={pageWidth} />}

                    {(inputField.editor.inputType.value === 'childId' ||
                      inputField.editor.inputType.value === 'parentId1' ||
                      inputField.editor.inputType.value === 'parentId2') &&
                      <IsraeliIdInput index={index} inputField={inputField} handleInputChange={handleInputChange} handleMouseEnter={handleMouseEnter} handleMouseLeave={handleMouseLeave} hoveredInde={hoveredIndex} windowWidth={renderedPdfWidth || windowWidth} pageHeight={pageHeight} pageWidth={pageWidth} />}

                    {inputField?.options?.length === 0 &&
                      !inputField.editor.inputType.value.includes('signature') &&
                      inputField.editor.inputType.value !== 'dateOfBirth' &&
                      inputField.editor.inputType.value !== 'signingDate' &&
                      inputField.editor.inputType.value !== 'childId' &&
                      inputField.editor.inputType.value !== 'parentId1' &&
                      inputField.editor.inputType.value !== 'parentId2' &&
                      <TextInput index={index} inputField={inputField} handleInputChange={handleInputChange} handleMouseEnter={handleMouseEnter} handleMouseLeave={handleMouseLeave} hoveredInde={hoveredIndex} windowWidth={renderedPdfWidth || windowWidth} pageHeight={pageHeight} pageWidth={pageWidth} />}
                  </div> : <div></div>
              ))}</>}
          </PdfContainer>

          {/* Navigation styled separately */}
          <StyledCard style={{ marginTop: spacing.md, overflow: 'hidden' }}>
            <NavigationCard>
              {(currentPage !== 1) && (
                <StyledButton
                  variant="outlined"
                  onClick={() => handlePageChange((currentPage === 1) ? currentPage : currentPage - 1)}
                  style={{ minWidth: '48px', padding: spacing.sm }}
                >
                  <KeyboardArrowRightIcon />
                </StyledButton>
              )}
              {(numPages > 1) && (
                <PageNumber>
                  {currentPage} / {numPages}
                </PageNumber>
              )}
              {(currentPage !== numPages) && (
                <StyledButton
                  variant="outlined"
                  onClick={() => handlePageChange((currentPage === numPages) ? currentPage : currentPage + 1)}
                  style={{ minWidth: '48px', padding: spacing.sm }}
                >
                  <KeyboardArrowLeftIcon />
                </StyledButton>
              )}
            </NavigationCard>
          </StyledCard>
        </div>

        {/* File Upload Section */}
        <div className={`${visibleDiv === 1 ? '' : 'hidden'}`}>
          <StyledCard style={{ marginBottom: spacing.lg, padding: spacing.xl }}>
            <RequestedFilesList
              requestedFiles={requestedFiles}
              files={files}
              setFiles={setFiles}
            />

            {requireID && (
              <FileUploadContainer>
                <FileUploadLabel
                  htmlFor="customFile"
                  direction={direction}
                >
                  {t('pdfSign.idPhotoLabel')}
                </FileUploadLabel>
                <input
                  id="customFile"
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />
                <label htmlFor="customFile" style={{ cursor: 'pointer', display: 'block' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: spacing.sm,
                      padding: spacing.lg,
                      border: `2px dashed ${selectedImage ? colors.success.main : colors.border.light}`,
                      borderRadius: radius.card,
                      backgroundColor: selectedImage ? colors.success.light : '#f9fafb',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: colors.primary.main,
                        backgroundColor: '#ffffff',
                      },
                    }}
                  >
                    {selectedImage ? (
                      <CheckCircleOutlineIcon sx={{ fontSize: 32, color: colors.success.main }} />
                    ) : (
                      <CloudUploadIcon sx={{ fontSize: 32, color: colors.text.secondary }} />
                    )}
                    <Typography sx={{ fontSize: typography.fontSize.sm, color: selectedImage ? colors.success.dark : colors.text.secondary }}>
                      {selectedImage
                        ? t('pdfSign.fileSelected', 'הקובץ נבחר בהצלחה')
                        : t('pdfSign.clickToUpload', 'לחץ לבחירת קובץ')}
                    </Typography>
                  </Box>
                </label>
              </FileUploadContainer>
            )}
          </StyledCard>
        </div>

        {/* Final Submission Section with Celebration */}
        <div className={`${visibleDiv === 2 ? '' : 'hidden'}`}>
          <CompletionScreen
            phoneNumber={approverPhoneNumber}
            onPhoneChange={(event) => setApproverPhoneNumner(event.target.value)}
            onSubmit={handleOpenPDF}
            isSubmitting={loading}
          />
        </div>

        {/* Navigation Buttons */}
        <NavigationButtons>
          {visibleDiv > 0 && (
            <StyledButton
              variant="outlined"
              onClick={handlePreviousClick}
            >
              {t('pdfSign.previous')}
            </StyledButton>
          )}
          {visibleDiv < 2 && (
            <StyledButton
              variant="contained"
              onClick={handleNextClick}
              sx={{ marginInlineStart: 'auto' }}
            >
              {t('pdfSign.next')}
            </StyledButton>
          )}
        </NavigationButtons>
      </ContentWrapper>
    </PageContainer>
  );
}